declare var _sr: any;

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataService } from '../services/dataService.service';

@Component({
  selector: 'app-newswidget',
  templateUrl: './newswidget.component.html',
  styleUrls: ['./newswidget.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewswidgetComponent implements OnInit {

    static componentName = 'NewswidgetComponent';
    news: any;
    showSection: any = false;

    constructor(
        private dataService: DataService,
    ) {}

    getPosts(): void {
        this.dataService.getPosts('post', false, 3)
            .subscribe(res => this.convertPostsObject(res));
    }

    convertPostsObject(res): void {
        this.news = Object.keys(res).map(function(resNamedIndex) {
            return res[resNamedIndex];
        });

        setTimeout(() => {
            _sr.reveal('.news-post');
        }, 1000);
    }

    getSectionState(): any {
        this.dataService.getField('/', 'option', 'show_news_section')
            .subscribe(res => this.showSection = res['show_news_section']);
    }

    ngOnInit() {
        this.getSectionState();
        this.getPosts();
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/newswidget/newswidget.component.ts